export var componentsLocales = {
  enterValue: 'Начните вводить значение',
  notFound: 'Ничего не найдено',
  updateValue: 'Начните вводить или изменять значение'
};